import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('LOCATION_REGIONS_FR').plugin(axiosPlugin, {template: "array"});

let fetchLocationRegionsFRAction = redux.fetchActionGet();

export const fetchLocationRegionsFR = (query = {}) => fetchLocationRegionsFRAction(`/locations?${queryString.stringify(query)}`);
export const resetLocationRegionsFR = () => redux.actions.reset();

export const locationRegionsFR = redux.reducer();